import React, { useEffect, useState } from "react";
import "./styles/InfoCis.css";
// import CisList from './CisList';
// import LoadSimple from '../LoadSimple';
import TableCisConfig from "./TableCisConfig";
import Search from "../generales/Search";
import Action from "../Action";
import ModalCreateCisConfig from "./ModalCreateCisConfig";
import ModalCisAfecta from "./ModalCisAfecta";
import ModalCisDocs from "./ModalCisDocs";
import Modal from "react-modal";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
/* estilos modal crear configuracion */
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};

/* estilos modal docs */
const CisDocsModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
/* estilos modal crear relacion */
const CisAfectaModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "90%",
    padding: "20px",
  },
};
const InfoCis = ({
  server,
  cisSelected,
  onSearch,
  dataUsers,
  setDataUsers,
  languaje,mode,
  dataCisConfig,
  setDataCisConfig,
  editActiveConfig,
  setEditActiveConfig,
}) => {
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [CisAfectaModalOpen, setCisAfectaModalOpen] = useState(false);
  const [CisDocsModalOpen, setCisDocsModalOpen] = useState(false);
  const [dataCisConf, setDataCisConf] = useState({
    data: [],
    loading: true,
    error: null,
  });


  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    // buscar_cis_history();
    setDataCisConf({
      data: {
        "message": "success",
        "success": true,
        "data": [
          {
            "id": 1,
            "name": "Google Chrome",
            "verify_path": [
              "C:\\Program Files (x86)\\Google\\Chrome",
              "C:\\Program Files\\Google\\Chrome"
            ],
            "install_endpoint": "/google/google-chrome/ws/install/",
            "uninstall_endpoint": "/google/google-chrome/ws/uninstall/",
            "status_endpoint": "/google/google-chrome/status/",
            "icon_name": "chrome.png",
            "operating_system_id": 1,
            "softwarekey": "windows10GoogleChrome",
            "status": "installing"
          },
          {
            "id": 2,
            "name": "AnyDesk",
            "verify_path": [
              "C:\\Program Files (x86)\\AnyDeskMSI",
              "C:\\Program Files\\AnyDeskMSI"
            ],
            "install_endpoint": "/anydesk/anydesk/ws/install/",
            "uninstall_endpoint": "/anydesk/anydesk/ws/uninstall/",
            "status_endpoint": "/anydesk/anydesk/status/",
            "icon_name": "anydesk.png",
            "operating_system_id": 1,
            "softwarekey": "windows10Anydesk",
            "status": "installing"
          },
          {
            "id": 3,
            "name": "Mobatek",
            "verify_path": [
              "C:\\Program Files (x86)\\Mobatek",
              "C:\\Program Files\\Mobatek"
            ],
            "install_endpoint": "/mobatek/mobatek/ws/install/",
            "uninstall_endpoint": "/mobatek/mobatek/ws/uninstall/",
            "status_endpoint": "/mobatek/mobatek/status/",
            "icon_name": "mobatek.png",
            "operating_system_id": 1,
            "softwarekey": "windows10Mobateck",
            "status": "unknown"
          },
          {
            "id": 4,
            "name": "Zoom",
            "verify_path": [
              "C:\\Program Files (x86)\\Zoom",
              "C:\\Program Files\\Zoom"
            ],
            "install_endpoint": "/zoom/zoom/ws/install/",
            "uninstall_endpoint": "/zoom/zoom/ws/uninstall/",
            "status_endpoint": "/zoom/zoom/status/",
            "icon_name": "zoom.png",
            "operating_system_id": 1,
            "softwarekey": "windows10Zoom",
            "status": "unknown"
          },
          {
            "id": 5,
            "name": "FortiClientVPN",
            "verify_path": [
              "C:\\Program Files (x86)\\Fortinet\\FortiClient",
              "C:\\Program Files\\Fortinet\\FortiClient"
            ],
            "install_endpoint": "/forticlientvpn/forticlientvpn/ws/install/",
            "uninstall_endpoint": "/forticlientvpn/forticlientvpn/ws/uninstall/",
            "status_endpoint": "/forticlientvpn/forticlientvpn/status/",
            "icon_name": "forticlientvpn.png",
            "operating_system_id": 1,
            "softwarekey": "windows10FortiClient",
            "status": "unknown"
          },
          {
            "id": 6,
            "name": "Firefox",
            "verify_path": [
              "C:\\Program Files (x86)\\Mozilla Firefox",
              "C:\\Program Files\\Mozilla Firefox"
            ],
            "install_endpoint": "/firefox/firefox/ws/install/",
            "uninstall_endpoint": "/firefox/firefox/ws/uninstall/",
            "status_endpoint": "/firefox/firefox/status/",
            "icon_name": "firefox.png",
            "operating_system_id": 1,
            "softwarekey": "windows10FireFox",
            "status": "installing"
          }
        ],
        "status_code": 200
      },
      loading: false,
      error: dataCisConf.error,
    });
  }, []);
  function closCreateCisModal() {
    setEditActiveConfig(false);
    setCreateCisModalOpen(false);
    buscar_cis_history();
  }


  function closeCisAfectaModal() {
    setCisAfectaModalOpen(false);
  }

  function openCisAfectaModal() {
    setCisAfectaModalOpen(true);
  }
  function closeCisDocsModal() {
    setCisDocsModalOpen(false);
  }

  function openCisDocsModal() {
    setCisDocsModalOpen(true);
  }


  const buscar_cis_history = () => {
    // setLoadingCis(true)
    setDataCisConf({
      data: dataCisConf.data,
      loading: true,
      error: dataCisConf.error,
    });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/provisioning_softwares_status/host/" +
            cisSelected.hostid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataCisConf({
            data: data1,
            loading: false,
            error: dataCisConf.error,
          });
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  try {
    return (
      <>
        <div style={{height:'100%',width:'20%',display:'flex',justifyContent:'center',alignContent:'center'}}>
        <img
                     
                      src="/iconos/workstation.png"
                      title="workstation"
                      alt="workstation"
                      name="workstation"
                      // ci_id={cisSelected.element_id}
                      // onClick={openCisAfectaModal}
                      style={{ width: "50%",height:'80%',top:'10%',position:'relative' }}
                    />
        </div>
        <div className="cont_info_cis-gs" style={{height:'90%',width:'80%'}}>
          <div className="top_info_cis-gs" style={{height:'100%'}}>
            <div className="row_info_cis-gs">
              <div className="title-info_cis-gs">
                <div style={{ width: "80%", justifyContent: "start" }}>
                  Device-ID:
                </div>
              </div>
              <div className="txt-info_cis-gs">{cisSelected.hostid}</div>
            </div>
            <div className="row_info_cis-gs" style={{height:'40%'}}>
              <div className="title-info_cis-gs">
                <div style={{ width: "80%", justifyContent: "start" }}>Host:</div>
              </div>
              <div className="txt-info_cis-gs" style={{fontSize:'18px'}}>{cisSelected.host}</div>
            </div>
            <div className="row_info_cis-gs">
              <div className="title-info_cis-gs">
                <div style={{ width: "80%", justifyContent: "start" }}>IP:</div>
              </div>
              <div className="txt-info_cis-gs">{cisSelected.ip}</div>
            </div>
            {/* <div className='row_info_cis'>
              <div className='title-info_cis'>
                      <div style={{width:'50%',justifyContent:'start'}}>
                      Tecnologia:
                      </div>
                      
                  </div>
                  <div className='txt-info_cis'>
                  {cisSelected.technology}
                  </div>
              </div> */}
            <div className="row_info_cis-gs">
              <div className="cel_row_info_cis-gs" style={{ width: "50%" }}>
                <div className="title-info_cis-gs" style={{ width: "80%" }}>
                {capitalizeFirstLetter(lang[languaje]['tecnologia'])}:
                </div>
                <div className="txt-info_cis-gs" style={{ width: "50%" }}>
                  {cisSelected.technology_name}
                </div>
              </div>
              <div className="cel_row_info_cis-gs" style={{ width: "50%" }}>
                <div className="title-info_cis-gs" style={{ width: "80%" }}>
                {capitalizeFirstLetter(lang[languaje]['sshCredentials'])}:
                </div>
                <div className="txt-info_cis-gs" style={{ width: "50%",color:(cisSelected.credentialsExist==0)?'red':'var(--txt-color)' }}>
                {(cisSelected.credentialsExist==0)?capitalizeFirstLetter(lang[languaje]['sinCredenciales']):capitalizeFirstLetter(lang[languaje]['conCredenciales'])}
                </div>
              </div>
              
            </div>
           
          </div>
          {/* <div className="body_info_cis" style={{height:'65%'}}>
            <div
              className="content-cis"
              style={{ border: "px solid #607582", boxShadow: "unset" }}
            >
              <div className="cont-cis-search" style={{ background: "#0166a0" }}>
                <>
                  <div className="cont-search hiddenPDF">
                    {dataCisConf.loading ? (
                      ""
                    ) : (
                      <Search
                        searchResults={searchResults}
                        setSearchResults={setSearchResults}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={onSearch}
                        dataObject={dataCisConf.data.data.history}
                        setDataObject={setDataCisConf}
                        languaje={languaje}
                        mode={mode}
                      />
                    )}
                  </div>
                  <div className="cont-search-space"></div>
                  <div className="cont-search-buttons hiddenPDF">
                    <Action
                      disabled={false}
                      origen="Blanco"
                      titulo="+ Crear Registro"
                      action={crear}
                    />
                  </div>
                </>
              </div>
  
              <div className="cont-cis-table">
                <div className="content-card-cis">
                  {dataCisConf.loading ? (
                    ""
                  ) : (
                    <TableCisConfig
                      buscar_cis_history={buscar_cis_history}
                      handleChangEdit={handleChangEdit}
                      cisSelected={cisSelected}
                      registerIsValid={true}
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      dataUsers={dataUsers}
                      setDataUsers={setDataUsers}
                      server={server}
                      setDataCisConf={setDataCisConf}
                      dataCisConf={dataCisConf}
                    ></TableCisConfig>
                  )}
                </div>
              </div>
            </div>
          </div> */}
        </div>
        {/* <Modal
          isOpen={CreateCisModalOpen}
          // isOpen={false}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closCreateCisModal}
          style={CreateCisModalStyles}
          contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
        >
          <ModalCreateCisConfig
            server={server}
            buscar_cis_history={buscar_cis_history}
            setEditActiveConfig={setEditActiveConfig}
            editActiveConfig={editActiveConfig}
            dataCisConfig={dataCisConfig}
            ci_id={cisSelected.element_id}
            closCreateCisModal={closCreateCisModal}
          ></ModalCreateCisConfig>
        </Modal> */}
  
        {/* modal documents */}
        <Modal
          isOpen={CisDocsModalOpen}
          // isOpen={false}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closeCisDocsModal}
          style={CisDocsModalStyles}
          contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
        >
          <ModalCisDocs
            server={server}
            cisSelected={cisSelected}
            closeCisDocsModal={closeCisDocsModal}
          ></ModalCisDocs>
        </Modal>
        <Modal
          isOpen={CisAfectaModalOpen}
          // isOpen={false}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closeCisAfectaModal}
          style={CisAfectaModalStyles}
          contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
        >
          <ModalCisAfecta
            server={server}
            cisSelected={cisSelected}
            closeCisAfectaModal={closeCisAfectaModal}
          ></ModalCisAfecta>
        </Modal>
      </>
    );
  } catch (error) {
    return(
     <InternalError/>
    )
  }
};

export default InfoCis;
